import type { MediaItemInterface } from '@hypercodestudio/basler-components';

import {
  PDP_GALLERY_PRIMARY_IMAGE_SIZES,
  PDP_GALLERY_SECONDARY_IMAGE_SIZES
} from '~/utils/imagePresetRegistry';

export function applyPdpGallerySlotSizes(
  media: MediaItemInterface,
  isPrimarySlot: boolean
): MediaItemInterface {
  if (media.type !== 'image') {
    return media;
  }

  return {
    ...media,
    content: {
      ...media.content,
      sizes: isPrimarySlot
        ? PDP_GALLERY_PRIMARY_IMAGE_SIZES
        : PDP_GALLERY_SECONDARY_IMAGE_SIZES
    }
  };
}
